import React from "react";
import PageLayout from "../components/PageLayout";
import Hero from "../components/Hero";
import FeatureColumns from "../components/FeatureColumns";
import NavyBand from "../components/NavyBand";
import HomeCTA from "../components/HomeCTA";

const Home = () => {
  return (
    <PageLayout showFooterQuote={true}>
      <Hero />
      <FeatureColumns />
      <NavyBand />
      <HomeCTA />
    </PageLayout>
  );
};

export default Home;
